import { resolveLocalized } from '@griply/utils';
import Typography from '@mui/material/Typography';
import { WhatsNewPage } from 'features/whats-new';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Sizes, Variants } from 'shared/components/ui/button';

import * as Styled from './whats-new-slide.style';

export type WhatsNewSlideProps = {
  page: WhatsNewPage;
};

export const WhatsNewSlide: React.FC<WhatsNewSlideProps> = ({ page }) => {
  const { t, i18n } = useTranslation();
  const language = i18n.language;

  const handleOpenLink = () => {
    if (!page.link) {
      return;
    }
    window.open(page.link.url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Styled.Container>
      {!!page.image && (
        <Styled.Image src={page.image} srcSet={page.imageSrcSet} alt="" />
      )}
      <Styled.Content>
        {!!page.newBadge && <Styled.Badge>{t('whats-new.badge')}</Styled.Badge>}
        <Styled.Titles>
          <Typography variant="h4" component="h2">
            {resolveLocalized(page.title, language)}
          </Typography>
          {!!page.subtitle && (
            <Typography variant="body2" component="p">
              {resolveLocalized(page.subtitle, language)}
            </Typography>
          )}
        </Styled.Titles>
        <Styled.Bullets>
          {page.bullets.map((bullet, index) => (
            <Styled.Bullet key={index}>
              <Typography variant="body2" component="p">
                <Styled.BulletLabel>
                  {resolveLocalized(bullet.title, language)}
                  {!!bullet.description && ':'}
                </Styled.BulletLabel>
                {!!bullet.description &&
                  ` ${resolveLocalized(bullet.description, language)}`}
              </Typography>
            </Styled.Bullet>
          ))}
        </Styled.Bullets>
        {!!page.link && (
          <Styled.LinkContainer>
            <Button
              variant={Variants.Text}
              size={Sizes.Medium}
              onClick={handleOpenLink}
            >
              {resolveLocalized(page.link.title, language)}
            </Button>
          </Styled.LinkContainer>
        )}
      </Styled.Content>
    </Styled.Container>
  );
};
